import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { isNullOrWhiteSpace } from 'ecs-react-components/dist/index.es';
import { messages } from './socialHistory.i18n';
import { SecondaryDisplayItem } from './secondaryDisplayItem';

export class SocialHistoryDetail extends React.Component {
  configurationActive = (fieldName) => {
    if (this.props.capabilities.details.find((x) => x.fieldName === fieldName)) {
      return true;
    }
    return false;
  }

  render() {
    const smokingStatus = isNullOrWhiteSpace(this.props.socialHistory.smokingStatusDisplay) ?
      this.props.socialHistory.smokingStatus :
      this.props.socialHistory.smokingStatusDisplay;
    const smokingPacksPerDay = isNullOrWhiteSpace(this.props.socialHistory.smokingPacksPerDayDisplay) ?
      this.props.socialHistory.smokingPacksPerDay :
      this.props.socialHistory.smokingPacksPerDayDisplay;
    const alcoholStatus = isNullOrWhiteSpace(this.props.socialHistory.alcoholStatusDisplay) ?
      this.props.socialHistory.alcoholStatus :
      this.props.socialHistory.alcoholStatusDisplay;
    return (
      this.props.socialHistory.isNullMessageHolder === false ?
      <div className="row item-row"
        data-qa={'socialHistory_' + this.props.socialHistory.socialHistoryId}
      >
        <div className="col-md-4 primary-data">
          {
            this.props.socialHistory.isPatientReviewed === false ?
              <span className="fa fa-circle"></span> : null
          }
          <FormattedMessage {...messages.labels.smokingAndAlcoholConsumption} />
        </div>
        <div className="col-md-8 secondary-data">
            <div className="inline-list">
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.smokingStatus} />}
                value={smokingStatus} language={this.props.language}
                isActive={this.configurationActive('SmokingStatus')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.smokingYears} />}
                value={this.props.socialHistory.smokingYears} language={this.props.language}
                isActive={this.configurationActive('SmokingYears')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.smokingPacksPerDay} />}
                value={smokingPacksPerDay} language={this.props.language}
                isActive={this.configurationActive('SmokingPacksPerDay')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.smokingYearsQuit} />}
                value={this.props.socialHistory.smokingYearsQuit} language={this.props.language}
                isActive={this.configurationActive('SmokingYearsQuit')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.alcoholStatus} />}
                value={alcoholStatus} language={this.props.language}
                isActive={this.configurationActive('AlcoholStatus')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.alcoholDaysPerWeek} />}
                value={this.props.socialHistory.alcoholDaysPerWeek} language={this.props.language}
                isActive={this.configurationActive('AlcoholDaysPerWeek')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.alcoholDrinksPerDay} />}
                value={this.props.socialHistory.alcoholDrinksPerDay} language={this.props.language}
                isActive={this.configurationActive('AlcoholDrinksPerDay')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.alcoholYearsQuit} />}
                value={this.props.socialHistory.alcoholYearsQuit} language={this.props.language}
                isActive={this.configurationActive('AlcoholYearsQuit')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.comment} />}
                value={this.props.socialHistory.comment} language={this.props.language}
                isActive={this.configurationActive('Comment')}
              />
            </div>
        </div>
      </div>
        :
      <div className="row item-row" data-qa="socialHistory_nullMessage">
        <div className="col-md-4 primary-data">
          {this.props.socialHistory.nullMessage}
        </div>
      </div>
    );
  }
}

SocialHistoryDetail.propTypes = {
  socialHistory: PropTypes.object.isRequired,
  language: PropTypes.string,
  capabilities: PropTypes.object.isRequired,
};
